import { useRef } from 'react';

/**
 * useDebounce Hook
 *
 * A custom React hook that debounces a function call. The function will only execute
 * after the specified delay has passed since the last time it was invoked.
 * Useful for optimizing performance by limiting the rate of function executio
 */
export default function useDebounce(callback, delay) {
  const timerRef = useRef(null);

  const debouncedFunction = (...args) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };

  const cancel = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  return { debouncedFunction, cancel };
}
